<template>
    <div id="app">
        <router-view></router-view>

        <template v-if="latestMessage">
            <div class="global-msg" v-if="$store.getters.enableGlobalMessage">
                <el-dialog
                        :title="latestMessage.target_type_label"
                        :visible.sync="showMessageDialog"
                        :close-on-press-escape="false"
                        width="20%"
                        center
                        :modal="false"
                        :modal-append-to-body="false"
                        custom-class="blue-link msg-dialog" :before-close="beforeClose">
                    <div v-html="latestMessage.content"></div>
                    <br/>
                    <span>{{latestMessage.relative_time}}</span>
                    <span slot="footer" class="dialog-footer">
                        <el-button :loading="submiting" type="text" @click="setHasRead(latestMessage)">已读</el-button>
                        <el-button type="text" @click="seeMoreMessages">查看更多</el-button>
                    </span>
                </el-dialog>
            </div>

        </template>


    </div>
</template>

<script>
    import {APP} from "~/config/app"
    import MessageService from "~/services/Message";
    import AccountService from '~/services/account'

    export default {
        name: 'app',
        data() {
            return {
                timeout: null,
                onfocus: true, // 当前窗口是否获得焦点状态
                showMessageDialog: false,
                latestMessage: null,
                submiting: false,
            };
        },
        created() {

            this.triggerGetGlobalMessages();

            this.timeout = setInterval(() => {
                this.pollingMessages();
            }, APP.polingMessageTime);
        },
        mounted() {

            if (document.hidden !== undefined) {
                document.addEventListener('visibilitychange', () => {
                    if (!document.hidden) {
                        this.onfocus = true;
                        //this.pollingMessages();
                    } else {
                        this.onfocus = false;
                    }
                })
            }

        },
        methods: {
            pollingMessages() {

                // 已经在消息页面没必要再弹出消息窗口
                if (this.$route.path == '/message/index' || this.$route.path == '/login') {
                    return;
                }

                // 对于消息框已经展开状态的情况下即暂停请求服务端获取最新消息
                // if (this.showMessageDialog == true) {
                //     return;
                // }

                // 当前页面已经禁止弹出消息框
                if (this.$store.getters.enableGlobalMessage == false) {
                    return;
                }

                if (this.onfocus) {
                    this.triggerGetGlobalMessages();
                }
            },

            triggerGetGlobalMessages() {

                if (AccountService.isGuest()) {
                    return;
                }

                this.$store.dispatch('getGlobalMessage').then(res => {
                    if (res && res.code == 0 && res.data.length > 0) {
                        this.latestMessage = res.data[0];
                        this.showMessageDialog = true;
                    }
                })
            },

            beforeClose() {
                this.showMessageDialog = false;
                // 当前页关闭消息窗口代表当前页不再弹出
                this.$store.dispatch('setGlobalMessageState', false);
            },

            seeMoreMessages() {
                this.$router.push({
                    path: "/message/index"
                })

                this.showMessageDialog = false;
            },

            setHasRead(message) {

                if (!message.id) {
                    return;
                }

                this.submiting = true;
                MessageService.batchSetRead({
                    messages: [message.id]
                }).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message: "执行成功!",
                            type: "success",
                            showClose: true,
                        });
                        this.showMessageDialog = false;
                    }
                    this.submiting = false;
                })
            }
        },

        beforeDestroy() {
            //clearTimeout(this.timeout);
            clearInterval(this.timeout)
        },
    };
</script>



// WEBPACK FOOTER //
// src/views/App.vue